import { Button } from '@/components/ui/button';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu';
import { useAuthStore } from '@/stores/auth';
import { useContextStore } from '@/stores/context';
import { useNavigate } from '@tanstack/react-router';
import { CircleUser } from 'lucide-react';

export function UserMenu(): React.JSX.Element {
  const navigate = useNavigate();
  const { user, signOut } = useAuthStore();
  const resetContext = useContextStore((s) => s.reset);

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button variant="ghost" size="icon" aria-label="Account">
          <CircleUser className="size-5" />
        </Button>
      </DropdownMenuTrigger>

      <DropdownMenuContent align="end">
        <DropdownMenuLabel className="font-normal text-muted-foreground">{user?.email}</DropdownMenuLabel>
        <DropdownMenuSeparator />
        <DropdownMenuItem
          onClick={async () => {
            await signOut();
            // The persisted context points at another user's org ids. Leaving it would hand the
            // next person to sign in on this machine a switcher aimed at rows they cannot read.
            resetContext();
            await navigate({ to: '/login' });
          }}
        >
          Sign out
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
